<template>
  <div>
    <div class="page_title">收银管理</div>
    <div class="firstLabel">

    </div>
    <div class="form_container">
      <div class="form">
        <div class="form_row">
          <div class="label">收款方式:</div>
          <select class="form_select" v-model="payMethod">
            <option v-for="item of cashierMethods" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
        </div>
        <div class="form_row" style="margin-top: 16px">
          <div class="label">众敏代收:</div>
          <span class="account_discription">{{ message_1 }}</span>
        </div>
        <div class="form_row">
          <div class="label">微信指定商户:</div>
          <span class="account_discription">{{ message_2 }}</span>
        </div>
        <div class="clew">{{ clew }}</div>
        <div class="button_container">
          <van-button class="button add" @click="addWxPayMerchant">新增商户</van-button>
          <van-button class="button" @click="changeWxPayMerchant">确认修改</van-button>
        </div>
        <div class="medium_title">收银调整日志：</div>
        <div class="flowContainer" v-for="(item,index) of cashier_change_logs" :key="index">
          <div class="flowContainer_row">
            <span class="flowContainer_label">操作时间:</span>
            <span>{{item.createTime}}</span>
          </div>
          <div class="flowContainer_row">
            <span class="flowContainer_label">操作内容:</span>
            <span>{{item.operationDesc}}</span>
          </div>
          <div class="flowContainer_row">
            <span class="flowContainer_label">操作人:</span>
            <span>{{item.userAccount}}</span>
          </div>
        </div>
        <div v-if="nullLogs">
          暂无收银调整日志
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {queryChangeCashierLogs, queryWxPayAccountByPartnerId} from "../graphql/api";
import {modWepayMerchant} from "../api";

export default {
  name: "cashier_mgr",
  inject: (['reload']),
  data() {
    return {
      cashierMethods: [
        {
          id: 0,
          name: '众敏代收'
        },
        {
          id: 1,
          name: '指定微信商户'
        }
      ],
      message_1: '客户支付的服务款项先到众敏账户下，众敏将服务款的商户应收部分（扣除众敏平台服务费后）实时划拨对应链点到商户账户下。商户可设定自动、或手动随时申请链点提现，众敏确保每日将提现部分打款给商户。',
      message_2: '客户支付的服务款项将直接到指定的微信商户下，众敏将通过微信分享实时划拨服务费。商户需要做必要的设定，并将商户的技术参数提供给众敏。',
      clew: '调整收银方式要慎重！',
      payMethod: 0,
      cashier_change_logs: [],
      page: 1,
      nullLogs: false
    }
  },
  mounted() {
    this.getCasjierLogs()
  },
  methods: {
    // 查询收银账户调整日志
    getCasjierLogs() {
      let params = {
        userAccount: sessionStorage.getItem('openid'),
        partnerId: sessionStorage.getItem('partnerid'),
        page: this.page
      }
      queryChangeCashierLogs(params).then(res => {
        try {
          this.cashier_change_logs = res.data.queryOperationFlow;
          if(!this.cashier_change_logs){
            this.nullLogs = true;
          }
        } catch (error) {
          this.nullLogs = true;
        }
      }).catch(error => {
        alert(`${error}`)
      });
    },

    // get
    // 修改微信收银账户
    changeWxPayMerchant() {
      let partnerId = sessionStorage.getItem('partnerid');
      let payMethod = this.payMethod;
      modWepayMerchant(partnerId, payMethod).then(res => {
        if (res.data.retcode == 0) {
          alert('修改收银方式成功');
          this.reload();
        } else {
          alert(`异常${res.data.retmsg}`)
        }
      }).catch(error => {
        alert(`异常${error}`)
      })
    },

    // 添加微信支付账户
    addWxPayMerchant() {
      this.$router.push('/apply_cashier')
    }
  }
}
</script>

<style src="../css/cashier_mgr.css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/cashier_mgr.vue